import { FC } from "react";
import { IconProps } from "./types";

export const CaretLeftSolid: FC<IconProps> = ({
  fill = "#000",
  width = 24,
  height = 24,
  className,
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width={width}
    height={height}
    className={className}
    {...props}
  >
    <path
      xmlns="http://www.w3.org/2000/svg"
      d="m7 12 10 8V4L7 12z"
      fill={fill}
    />
  </svg>
);
